import React, { lazy, Suspense, useCallback, useRef, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { Container } from 'components/UI';
import { Title } from '@landing/ui';
import { Slider, SliderControl } from 'components/Slider';
import Slide from './Slide';
import { useIsSsr } from 'utils/hooks';

import * as styles from './Interview.module.scss';

const Animation = lazy(() => import('components/UI/Animation'));

export default function Interview({ title, subtitle, slides }) {
  const isSsr = useIsSsr();
  const [inViewRef, inView] = useInView({
    triggerOnce: true,
  });
  const sliderRef = useRef(null);
  const [current, setCurrent] = useState(1);

  const setCurrentIndex = useCallback((prev, next) => {
    setCurrent(next + 1);
  }, []);

  const handleNext = useCallback(() => {
    sliderRef.current.slickNext();
  }, [sliderRef]);

  const handlePrev = useCallback(() => {
    sliderRef.current.slickPrev();
  }, [sliderRef]);

  const settings = {
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <Container className={styles.container} background="transparent">
      <div className={styles.layout}>
        <Title color="white" className={styles.title}>
          {title}
        </Title>
        <p className={styles.subtitle}>{subtitle}</p>
        <div className={styles.sliderWrapper} ref={inViewRef}>
          {inView && (
            <>
              <Slider ref={sliderRef} beforeChange={setCurrentIndex} {...settings}>
                {slides.map(slide => (
                  <Slide key={slide.youtubeVideo} {...slide} />
                ))}
              </Slider>
              {slides.length > 1 && (
                <div className={styles.sliderControlsWrapper}>
                  <SliderControl
                    className={styles.sliderControls}
                    current={current}
                    to={slides.length}
                    handleNext={handleNext}
                    handlePrev={handlePrev}
                  />
                </div>
              )}
            </>
          )}
        </div>
      </div>
      {!isSsr && (
        <Suspense fallback={null}>
          <Animation preserveAspectRatio className={styles.animation} name="calculator" />
        </Suspense>
      )}
    </Container>
  );
}
